<!-- Ported from the Polaris kit: src/components/ui/card/Card.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="card"
    :class="
      cn(
        'bg-polaris-card text-polaris-card-foreground flex flex-col gap-6 rounded-polaris-xl border border-solid border-polaris-border py-6 shadow',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
